import React from 'react';

const About = () => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8 col-md-10">
          <div className="glass-card">
            <h1 className="commercial-heading mb-4">About ObitAuthor</h1>
            
            <div className="mb-4">
              <h2 className="commercial-subheading mb-3">Our Mission</h2>
              <p style={{ color: '#000000', lineHeight: '1.8', fontSize: '1.1rem', marginBottom: '1.5rem' }}>
                At ObitAuthor, we understand that losing a loved one is one of life's most difficult experiences. 
                During this challenging time, the last thing you should worry about is writing an obituary. Our mission 
                is to provide families with a compassionate, professional, and affordable service that honors the memory 
                of their loved ones with dignity and respect.
              </p>
            </div>

            <div className="mb-4">
              <h2 className="commercial-subheading mb-3">What We Do</h2>
              <p style={{ color: '#000000', lineHeight: '1.8', fontSize: '1.1rem', marginBottom: '1.5rem' }}>
                ObitAuthor uses advanced AI technology to help you create beautiful, personalized obituaries in minutes. 
                Simply answer a few questions about your loved one, and we'll craft a professional obituary that captures 
                their life story, achievements, and the impact they had on those around them.
              </p>
              <p style={{ color: '#000000', lineHeight: '1.8', fontSize: '1.1rem', marginBottom: '1.5rem' }}>
                Our service is designed to be:
              </p>
              <ul style={{ color: '#000000', lineHeight: '1.8', fontSize: '1.1rem', marginLeft: '2rem', marginBottom: '1.5rem' }}>
                <li><strong>Affordable:</strong> At just $9.99 for up to 5 obituaries, we offer significant savings compared to traditional funeral home services</li>
                <li><strong>Convenient:</strong> Create obituaries from the comfort of your home, at any time that works for you</li>
                <li><strong>Professional:</strong> Each obituary is carefully crafted with attention to detail and respect</li>
                <li><strong>Flexible:</strong> Your codes never expire, so you can use them whenever you need them</li>
              </ul>
            </div>

            <div className="mb-4">
              <h2 className="commercial-subheading mb-3">Why Choose ObitAuthor?</h2>
              <p style={{ color: '#000000', lineHeight: '1.8', fontSize: '1.1rem', marginBottom: '1.5rem' }}>
                Traditional funeral homes and crematoriums often charge $200-$500 or more to write an obituary. At ObitAuthor, 
                we believe that honoring your loved one shouldn't come with an exorbitant price tag. Our service provides 
                the same professional quality at a fraction of the cost, giving you one less thing to worry about during 
                this difficult time.
              </p>
            </div>

            <div className="mb-4">
              <h2 className="commercial-subheading mb-3">Our Commitment</h2>
              <p style={{ color: '#000000', lineHeight: '1.8', fontSize: '1.1rem', marginBottom: '1.5rem' }}>
                We are committed to providing compassionate, respectful service to every family we serve. Our team understands 
                the sensitivity of this time and works diligently to ensure that each obituary truly honors the memory of your 
                loved one. If you're not satisfied with your obituary, we'll work with you to make it right.
              </p>
            </div>

            <div className="mb-4">
              <h2 className="commercial-subheading mb-3">Contact Us</h2>
              <p style={{ color: '#000000', lineHeight: '1.8', fontSize: '1.1rem', marginBottom: '1.5rem' }}>
                If you have any questions or need assistance, please don't hesitate to{' '}
                <a href="/help" style={{ color: '#1e40af', textDecoration: 'underline' }}>contact our support team</a>. 
                We're here to help.
              </p>
            </div>

            <div className="text-center mt-5">
              <a href="/" className="btn btn-primary btn-lg">
                Get Started
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;



